export function useDownload(fileUrl) {

    return new Promise(resolve => {
        const link = window.document.createElement('a')
        link.href = fileUrl
        link.click()
        resolve()
    })
}